"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_fontawesome_1 = require("@fortawesome/react-fontawesome");

var free_brands_svg_icons_1 = require("@fortawesome/free-brands-svg-icons");

var styled_1 = __importDefault(require("@emotion/styled"));

var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");

var Row_1 = require("./Row");

var Column_1 = require("./Column");

var colors_1 = require("./colors");

var Text = styled_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 24px;\n"], ["\n  font-size: 24px;\n"])));
var SocialLink = styled_1.default.a(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (props) {
  return colors_1.getColor(props);
});
var StyledRow = styled_1.default(Row_1.Row)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: 10px 0;\n  display: ", ";\n\n  @media (min-width: ", "px) {\n    display: flex;\n  }\n"], ["\n  padding: 10px 0;\n  display: ", ";\n\n  @media (min-width: ", "px) {\n    display: flex;\n  }\n"])), function (_a) {
  var xsHide = _a.xsHide;
  return xsHide ? 'none' : 'flex';
}, function (_a) {
  var theme = _a.theme;
  return theme.thresholds.md;
});

exports.Share = function (_a) {
  var href = _a.href,
      title = _a.title,
      description = _a.description,
      showTitle = _a.showTitle,
      xsHide = _a.xsHide,
      props = __rest(_a, ["href", "title", "description", "showTitle", "xsHide"]);

  return href ? react_1.default.createElement(StyledRow, __assign({
    justify: "center",
    align: "center",
    xsHide: xsHide
  }, props), react_1.default.createElement(Column_1.Column, null, showTitle ? react_1.default.createElement(Text, null, "Share:") : null), react_1.default.createElement(Column_1.Column, null, react_1.default.createElement(SocialLink, __assign({}, props, {
    href: "https://www.facebook.com/sharer.php?u=" + href
  }), react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, {
    icon: free_brands_svg_icons_1.faFacebookSquare,
    size: "lg"
  }))), react_1.default.createElement(Column_1.Column, null, react_1.default.createElement(SocialLink, __assign({}, props, {
    href: "https://twitter.com/intent/tweet?url=" + href
  }), react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, {
    icon: free_brands_svg_icons_1.faTwitter,
    size: "lg"
  }))), react_1.default.createElement(Column_1.Column, null, react_1.default.createElement(SocialLink, __assign({}, props, {
    href: "http://pinterest.com/pin/create/button/?url=" + href + (description ? "&description=" + description : '')
  }), react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, {
    icon: free_brands_svg_icons_1.faPinterest,
    size: "lg"
  }))), react_1.default.createElement(Column_1.Column, null, react_1.default.createElement(SocialLink, __assign({}, props, {
    href: "https://www.linkedin.com/shareArticle?mini=true&url=" + href
  }), react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, {
    icon: free_brands_svg_icons_1.faLinkedinIn,
    size: "lg"
  }))), react_1.default.createElement(Column_1.Column, null, react_1.default.createElement(SocialLink, __assign({}, props, {
    href: "mailto:?subject=Kolla in " + (title !== null && title !== void 0 ? title : 'Gårdsbutiker') + "&body=H\xE4r \xE4r en l\xE4nk till " + (title !== null && title !== void 0 ? title : 'Gårdsbutiker') + " " + href + ". " + (description ? "\n" + description : '')
  }), react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, {
    icon: free_solid_svg_icons_1.faEnvelope,
    size: "lg"
  })))) : null;
};

var templateObject_1, templateObject_2, templateObject_3;